import { render } from "./GameModule.vue?vue&type=template&id=61081184"
import script from "./GameModule.vue?vue&type=script&lang=ts"
export * from "./GameModule.vue?vue&type=script&lang=ts"

import "../../assets/scss/modules/game.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script